import { apiClient } from '@/services/ApiClient.js'

export class PhoneSurveyService {
  static getPhoneSurveys() {
    return apiClient
      .get('phone-surveys')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getPhoneSurvey(phoneSurveyId) {
    return apiClient
      .get('phone-surveys/' + phoneSurveyId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static sortQuestions(questions) {
    let phoneSurveyId = questions[0].phone_survey_id

    return apiClient
      .patch('phone-surveys/' + phoneSurveyId + '/sort', {
        ids: questions.map(function (question) {
          return question.id
        })
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static toggleStatus(phoneSurveyId) {
    return apiClient
      .patch('phone-surveys/' + phoneSurveyId + '/toggle-status')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getQuestionTypes() {
    return apiClient
      .get('phone-surveys/question-types')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static createQuestion(question) {
    return apiClient
      .post('phone-survey-questions', question)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getQuestion(questionId) {
    return apiClient
      .get('phone-survey-questions/' + questionId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static updateQuestion(question) {
    return apiClient
      .patch('phone-survey-questions/' + question.id, question)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
